module.exports = __webpack_public_path__ + "static/media/Frank Gotthardt.b9239e1e.jpg";